import $ from "jquery";
import "datatables.net";
import "datatables.net-dt";

function triggerParkingOverlay() {
  const parkingWrapper = document.querySelector(".parking-overlay");
  const triggers = document.querySelectorAll(".js-open-parking-window");
  const close = document.querySelector(".js-close-parking-window");

  function updateObjectsStatusOnMap() {
    // UPDATE STATUS START
    const rows = document.querySelectorAll(".parking-table-row");

    rows.forEach((row) => {
      const rowID = row.dataset.plan;
      const status = row.dataset.status;
      const objects = document.querySelectorAll(
        `.parking-object[id='${rowID}']`
      );

      objects.forEach((object) => {
        object.dataset.status = status;
      });
    });
    // UPDATE STATUS END
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", function () {
      parkingWrapper.classList.add("visible");
      document.documentElement.style.overflow = "hidden";

      updateObjectsStatusOnMap();
    });
  });

  if (
    document.body.classList.contains("page-template-template-parking-plans")
  ) {
    updateObjectsStatusOnMap();
  }

  if (
    !document.body.classList.contains("page-template-template-parking-plans")
  ) {
    close.addEventListener("click", function () {
      parkingWrapper.classList.remove("visible");
      document.documentElement.style.overflow = "";
    });

    window.onkeydown = function (event) {
      if (event.keyCode == 27) {
        parkingWrapper.classList.remove("visible");
        document.documentElement.style.overflow = "";
      }
    };
  }
}

export { triggerParkingOverlay };

function initParkingTable() {
  $(document).ready(function () {
    const table = $(".parking-table").DataTable({
      paging: false,
      scrollY: "calc(100vh - 200px)",
      scrollCollapse: true,
      aoColumnDefs: [{ sType: "num", aTargets: [0] }],
      order: [[0, "asc"]],
      drawCallback: function (settings) {
        triggerParkingObjectsOnImage();

        $(".parking-object").on("mouseenter touchstart", function () {
          const id = $(this).attr("id");

          $(".parking-table tr[data-plan='" + id + "']").addClass("rowHover");

          const row = $(`[data-plan=${id}]`);
          if (row[0] !== undefined) {
            table.context[0].nScrollBody.scrollTo(0, row[0].offsetTop);
          }
        });

        $(".parking-object").on("mouseleave touchend", function () {
          const id = $(this).attr("id");

          $(".parking-table tr[data-plan='" + id + "']").removeClass(
            "rowHover"
          );
        });
      },
    });

    table.columns([0]).visible(false, false);
    table.columns.adjust().draw(false); // adjust column sizing and redraw

    // filter only available spaces
    const availFilter = document.querySelector(".availability-filter-parking");

    availFilter.addEventListener("change", function () {
      const input = availFilter.querySelector("input");
      if (input.checked) {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex) {
          return $(table.row(dataIndex).node()).attr("data-status") != 2;
        });
        table.draw();
      } else {
        // table.columns(3).search("").draw();
        $.fn.dataTable.ext.search.pop();
        table.draw();
      }
    });

    // -----------------------------------------//
    function triggerParkingObjectsOnImage() {
      const tableRows = document.querySelectorAll(".parking-table tbody tr");

      tableRows.forEach((row) => {
        $(row)
          .off("mouseenter")
          .on("mouseenter", function () {
            const rowID = row.dataset.plan;
            const objects = document.querySelectorAll(
              `.parking-object[id=${rowID}]`
            );

            objects.forEach((object) => {
              object.classList.add("active");
            });
          });
      });

      tableRows.forEach((row) => {
        $(row)
          .off("mouseleave")
          .on("mouseleave", function () {
            const rowID = row.dataset.plan;
            const objects = document.querySelectorAll(
              `.parking-object[id=${rowID}]`
            );

            objects.forEach((object) => {
              object.classList.remove("active");
            });
          });
      });
    }

    // -----------------------------------------//

    setTimeout(function () {
      availFilter.click();
    }, 1000);
  });
}

export { initParkingTable };
